import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";

const SectionCard = ({
                         title,
                         subtitle,
                         children,
                         borderColor = "#d32f2f",  // default red accent
                         backgroundColor = "#fafafa", // default light background
                     }) => {
    return (
        <Box sx={{ px: { xs: 2, md: 6 }, py: 4, backgroundColor }}>
            <Card
                elevation={2}
                sx={{
                    borderRadius: 2,
                    borderLeft: `5px solid ${borderColor}`,
                }}
            >
                <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: 700,
                            mb: subtitle ? 1 : 3,
                            color: "#212121",
                            textAlign: "left",
                        }}
                    >
                        {title}
                    </Typography>

                    {subtitle && (
                        <Typography
                            variant="body2"
                            sx={{
                                color: "#666666",
                                mb: 3,
                                textAlign: "left",
                                fontWeight: 500,
                                letterSpacing: "0.5px",
                            }}
                        >
                            {subtitle}
                        </Typography>
                    )}

                    {children}
                </CardContent>
            </Card>
        </Box>
    );
};

export default SectionCard;
